<template>
    <div :class="[ getCurrentEvent?.id ]" class="layout-entrance">
        <div class="sidebar">
            <div class="header">
                <div class="mincifry">
                    <IconAlert class="icon mincifry-icon" />

                    <TooltipOld bind-to=".mincifry-icon"
                                class="hint"
                                trigger-on="hover">Показать информацию о
                        сертификатах
                    </TooltipOld>

                    <TooltipOld ref="mincifry"
                                bind-to=".mincifry-icon"
                                class="tooltip mincifry-tooltip"
                                closeable
                                trigger-on="click">
                        <InformNotice class="inform">
                            <template #icon>
                                <IconInfo class="icon" />
                            </template>

                            <template #text>
                                <div class="title">Нужны сертификаты Минцифры РФ</div>
                                <div class="desc">Для стабильной работы сайта необходимо установить сертификаты
                                </div>
                                <div class="actions">
                                    <router-link :to="{ name:'install-certificates' }" class="action">Подробнее
                                    </router-link>
                                </div>
                            </template>
                        </InformNotice>
                    </TooltipOld>
                </div>

                <div class="logo-container">
                    <div class="logo"></div>
                </div>
            </div>

            <div class="middle">
                <Transition mode="out-in" name="slide-left-to-right">
                    <slot />
                </Transition>
            </div>

            <div class="footer">
                <div class="helpme">
                    Если возникли вопросы, то обратитесь в
                    <a class="accent" href="https://helpme.rt.ru/tickets/create/sm/3806" target="_blank">HelpMe</a>
                </div>
                <div class="two-sided">
                    <div class="left">Ростелеком ИТ</div>
                    <div class="right">{{ year }}</div>
                </div>
            </div>
        </div>
        <div class="welcome">
            <div :class="[ getCurrentEvent?.id ]" class="logo" />
        </div>
    </div>
</template>

<script>
import EventsMixin from '@/common/events/common/mixins/events.mixin.js';
import InformNotice from '@/common/page_comp/InformNotice/InformNotice.vue';
import IconAlert from '@/layouts/entrance/icons/alert.svg?component';
import IconInfo from '@/layouts/entrance/icons/info.svg?component';


export default {
    name: 'Entrance',
    mixins: [ EventsMixin ],
    components: {
        InformNotice,
        IconAlert,
        IconInfo,
    },
    computed: {
        year() {
            return new Date().getFullYear();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@dsee/mixins";

.layout-entrance {
    display: flex;
    flex-flow: row nowrap;
    min-height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    background-color: rgba(34, 55, 57, 1);
    background-image: url('./images/bg.png');

    &.NEW_YEAR {
        background-image: url('./images/bg_new_year.png');
    }

    .welcome {
        flex: auto;
        position: relative;
        overflow: hidden;

        @media (max-width: 1023px) {
            display: none;
        }
    }

    .welcome > .logo {
        background-image: url('./icons/logo.svg');
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        @include icon(470px, 116px);
        cursor: default;
        z-index: 0;

        &.NEW_YEAR {
            background-image: url('./icons/logo_new_year.svg');
            @include icon(470px, 173px);
        }
    }

    .sidebar {
        display: flex;
        flex-flow: column nowrap;
        justify-content: space-between;
        padding-bottom: 40px;
        max-width: 580px;
        width: 100%;
        max-height: 760px;
        margin-top: 70px;
        margin-left: 100px;
        margin-bottom: 20px;
        flex: none;
        background: #FFFFFF;
        border-radius: 24px;
        position: relative;
        z-index: 1;

        @media (max-width: 1023px) {
            max-width: 70%;
            max-height: 100%;
        }

        @media (max-width: 767px) {
            margin: 0;
            padding: 0;
            border-radius: 0;
            max-width: 100%;
        }

        @media (min-width: 768px) and (max-width: 1023px) {
            margin-top: 30px;
            margin-left: 30px;
        }

        & > * {
            flex: none;
            padding: 0 60px;

            @media (max-width: 767px) {
                padding: 0 32px;
            }
        }

        .header {
            height: 64px;

            .mincifry {
                position: absolute;
                right: -50px;
                top: 0;

                .mincifry-icon {
                    cursor: pointer;
                }

                @media (max-width: 1023px) {
                    display: none;
                }
            }

            @media (max-width: 1023px) {
                height: 32px;
            }

            .logo-container {
                display: flex;
                justify-content: space-between;
                margin-bottom: 12px;
                margin-top: 32px;

                .logo {
                    background-image: url('./icons/logo_green.svg');
                    @include icon(130px, 32px);
                }

                @media (min-device-width: 1024px) {
                    display: none;
                }
            }
        }

        .footer {
            color: var(--additional-color);
            margin-top: 12px;

            .helpme {
                margin-bottom: 16px;
            }

            @media (max-device-width: 1024px) {
                margin-bottom: 12px;
            }
        }
    }
}

.mincifry-tooltip {
    --border-color: rgba(255, 236, 200, 1);;
    --background-color: rgba(255, 236, 200, 1);
    padding: 0;
    max-width: none;
    transform: translate3d(50px, -50px, 0);

    :deep(.close) {
        position: absolute;
        top: 14px;
        right: 14px;
    }

    .inform {
        background: rgba(255, 236, 200, 1);
        align-items: start;

        .title {
            font-size: 12px;
            font-weight: 500;
            line-height: 16px;
            letter-spacing: 0.02em;
            margin-bottom: 4px;
            color: var(--text-color);
        }

        .desc {
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
            color: rgba(16, 24, 40, 0.85);
            margin-bottom: 12px;
        }

        .action {
            background: #fff;
            display: inline-flex;
            padding: 4px 12px;
            border-radius: var(--input-border-radius);
            font-size: 12px;
            font-weight: 500;
            line-height: 16px;
            letter-spacing: 0.02em;
        }

    }

    &::before {
        left: -16px !important;
        top: 15px;
        transform: rotate(-90deg);
    }

    &::after {
        left: -15px !important;
        top: 15px;
        transform: rotate(-90deg);
    }
}
</style>

<style lang="scss">
@import "@dsee/mixins";

.layout-entrance .sidebar .middle {
    font-size: var(--text-font-size);
    line-height: var(--text-line-height);
    max-height: 100%;
    overflow: auto;
    @include scrollbar;

    .block-title {
        font-size: 26px;
        font-weight: 700;
        line-height: 36px;
        margin-bottom: 32px;
        display: flex;

        > .loader {
            height: auto;
            width: 56px;
            margin-left: 16px;
        }
    }

    .form-field {
        --form-field-margin: 12px;
    }

    .form-action {
        --form-field-margin: 24px;

        .action {
            text-align: center;
            display: block;
        }
    }

    .additional {
        margin-top: 12px;
    }

    .message {
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: 0.02em;
        margin-bottom: 8px;
        word-break: break-word;
    }

    .message.error {
        color: rgba(255, 38, 38, 1);
    }

    .notification {
        padding: 20px;
        display: flex;
        gap: 8px;
        align-items: center;
        border-radius: var(--input-border-radius);
        margin-bottom: 24px;
        background-color: rgba(255, 38, 38, 0.12);

        &:not(.error) {
            background-color: var(--overlay-background);

            .icon {
                color: var(--action-main-color);
            }
        }

        &.warning {
            background-color: rgba(253, 166, 16, 0.16);

            .icon {
                color: var(--action-main-color);
            }
        }

        .icon {
            flex: none;
        }

        .title {
            font-size: 12px;
            line-height: 16px;
            font-weight: 500;
        }

        .description {
            a {
                color: var(--link-color);
            }
        }
    }
}
</style>
